<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col class="content_inner">
        <div class="margin-bottom-2x">
          <span @click="back" class="curson-pointer font-size-14 text-body-2">
            <v-icon left style="margin-right:0">mdi-chevron-left</v-icon>返回
          </span>
        </div>
        <v-card class="form-card card-padding">
          <h2 class="card-title">查看方案</h2>
          <v-tabs v-model="tabValue">
            <v-tab key="base">基础信息</v-tab>
            <v-tab key="detail">布局设置</v-tab>
          </v-tabs>
          <v-card-text>
            <v-form ref="form">
              <ul v-show="tabValue === 0" class="form-ul label-width-9">
                <li>
                  <span class="label">方案code：</span>
                  <div class="text"> {{ scheme.code }}
                  </div>
                </li>
                <li>
                  <span class="label">名称：</span>
                  <div class="text"> {{ scheme.name }}
                  </div>
                </li>
                <li>
                  <span class="label">用户类型：</span>
                  <div class="text">
                    {{ scheme.userType ? userTypeList.find(e => e.label === scheme.userType).name : '' }}
                  </div>
                </li>
                <li>
                  <span class="label">平台类型：</span>
                  <div class="text">
                    <!-- {{scheme.platType ? platTypeLevel.find(e => e.code === scheme.platType).name : ''}} -->
                    {{ handlePlatType(scheme.platType) }}
                    <!-- scheme.platType -->
                  </div>
                </li>
                <li>
                  <span class="label">创建时间：</span>
                  <div class="text"> {{ scheme.createTime }}
                  </div>
                </li>
                <li>
                  <span class="label">说明：</span>
                  <div class="text"> {{ scheme.description }}
                  </div>
                </li>
              </ul>
            </v-form>
            <iframe class="iframe-view" v-if="tabValue === 1" :src="toSchemeEditView" frameborder="0"></iframe>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
  },
  data () {
    return {
      colorText: ['indigo--text', 'deep-orange--text', 'teal--text'],
      tabValue: 0,
      scheme: JSON.parse(sessionStorage.getItem('schemeDetail')),
      toSchemeEditView: ''
    }
  },
  computed: {
    ...mapState(['platTypeLevel', 'userTypeList', 'componentTypeList', 'iconDirectoryList', 'token'])
  },
  watch: {
  },
  beforeDestroy () {
  },
  created () {
  },
  mounted () {
    // const data = JSON.parse(sessionStorage.schemeDetail)
    // const token = localStorage.token
    // console.log('process', process.env.NODE_ENV === 'development')
    let url = ''
    if (process.env.NODE_ENV === 'development') {
      url = 'http://192.168.3.190:9991'
      // url = 'http://10.9.13.44:8090/cloud-scheme'
    } else {
      url = window.location.origin
    }
    console.log(this.scheme)
    this.toSchemeEditView = `${url}/cloud-scheme?token=${this.token}&name=${this.scheme.name}&platType=${this.scheme.platType}&userType=${this.scheme.userType}&code=${this.scheme.code}&type=${this.scheme.type}&readonly=1`
  },
  methods: {
    back () {
      this.$router.back(-1)
      sessionStorage.removeItem('schemeDetail')
    },
    handlePlatType (platType) {
      //
      const platTypeArr = []
      const arr = platType.split(',')
      for (const val of arr) {
        console.log(val, this.platTypeLevel)
        platTypeArr.push(this.platTypeLevel.find(e => e.code === val).name)
      }
      return platTypeArr.join(' / ')
    }
  }
}
</script>
<style>
.v-slider__thumb {
  cursor: pointer;
}
</style>
